

export class AlertGroupSelectActiveOutputData implements IAlertGroupSelectActiveOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The alert group name with 255 character limit */
    alert_group_name!: string;

    constructor(data?: IAlertGroupSelectActiveOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_group_id = _data["alert_group_id"];
            this.alert_group_name = _data["alert_group_name"];
        }
    }

    static fromJS(data: any): AlertGroupSelectActiveOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupSelectActiveOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_group_id"] = this.alert_group_id;
        data["alert_group_name"] = this.alert_group_name;
        return data; 
    }
}

export interface IAlertGroupSelectActiveOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The alert group name with 255 character limit */
    alert_group_name: string;
}

